var exports = {
  "uW": "PurchaseHistorySection.module__section___VmZDbz",
  "Nr": "PurchaseHistorySection.module__card___VmZDbz",
  "Vg": "PurchaseHistorySection.module__grid___VmZDbz",
  "Qs": "PurchaseHistorySection.module__content___VmZDbz",
  "DD": "PurchaseHistorySection.module__title___VmZDbz",
  "h_": "PurchaseHistorySection.module__description___VmZDbz",
  "be": "PurchaseHistorySection.module__accordionStack___VmZDbz",
  "JC": "PurchaseHistorySection.module__accordion___VmZDbz",
  "x6": "PurchaseHistorySection.module__button___VmZDbz",
};

module.exports = exports;
